import {createTheme} from '@mui/material/styles';

export const theme = createTheme({
    components: {
        MuiInputBase: {
            styleOverrides: {
                formControl: {
                    fontFamily: 'Mulish, sans-serif',
                    height: '40px',
                    alignItems: 'center',
                    '& .MuiOutlinedInput-input': {
                        border: 'none',
                    },
                },

            },
        },
        MuiInputLabel: {
            styleOverrides: {
                formControl: {
                    backgroundColor: '#FFF',
                    fontFamily: 'Mulish, sans-serif',
                    fontWeight: 600,
                    fontSize: 16,
                    color: '#555770'
                },
                root: {
                    transform: 'translate(10px, -10px) scale(0.75)', // Diminui o tamanho ao focar
                },
            },
        },
    },
});

export default theme;